class ModalController {
    constructor() {
        this.confirmFn = null;
    }
    setConfirmFn(fn) {
        this.confirmFn = fn;
    }
    static getInstance() {
        if (!ModalController.instance) {
            ModalController.instance = new ModalController();
        }
        return ModalController.instance;
    }
    async confirm(props) {
        if (!this.confirmFn) {
            throw new Error('[ModalController] ModalProvider not mounted.');
        }
        return this.confirmFn(props);
    }
}
export default ModalController;
